import { lazy } from "react";

const routes = [
  {
    path: "/subcategory",
    element: lazy(() => import("../pages/SubCategory")),
  },
  {
    path: "/subcategory/add",
    element: lazy(() => import("../pages/SubCategory/create-update")),
  },
  {
    path: "/subcategory/add/:id",
    element: lazy(() => import("../pages/SubCategory/create-update")),
  },
];

export default routes;
